export const iconFontAwesomeAccessibilityClosedCaptioning = (
	<i className="fa-solid fa-closed-captioning"></i>
);
